import DetailDialog from "common/components/DetailDialog";
import { AnimalPerformanceTab } from "./tabs/AnimalPerformanceTab";
import { BiodiversityTab } from "./tabs/BiodiversityTab";
import { CarbonFootprintTab } from "./tabs/CarbonFootprintTab";
import { GrazingManagementTab } from "./tabs/GrazingManagementTab";
import { MilkQualityTab } from "./tabs/MilkQualityTab";
import { WaterSoilTab } from "./tabs/WaterSoilTab";

export type InsightCategory =
  | "carbon-footprint"
  | "biodiversity"
  | "water-soil"
  | "grazing-management"
  | "animal-performance"
  | "milk-quality";

const CATEGORIES: Record<
  InsightCategory,
  { title: string; Component: React.FC<{ farmerGuid?: string }> }
> = {
  "carbon-footprint": {
    title: "Carbon Footprint",
    Component: CarbonFootprintTab,
  },
  biodiversity: {
    title: "Biodiversity",
    Component: BiodiversityTab,
  },
  "water-soil": {
    title: "Water & Soil Quality",
    Component: WaterSoilTab,
  },
  "grazing-management": {
    title: "Grazing Management",
    Component: GrazingManagementTab,
  },
  "animal-performance": {
    title: "Animal Performance",
    Component: AnimalPerformanceTab,
  },
  "milk-quality": {
    title: "Milk Quality",
    Component: MilkQualityTab,
  },
};

export default function InsightDetailDialog({
  open,
  category,
  onClose,
  onBack,
  farmerGuid,
}: {
  open: boolean;
  category: InsightCategory | null;
  onClose: () => void;
  onBack?: () => void;
  farmerGuid?: string;
}) {
  const config = category ? CATEGORIES[category] : null;

  return (
    <DetailDialog
      open={open}
      onClose={onClose}
      onBack={onBack}
      title={config?.title}
      contentSx={{ backgroundColor: "#F7FCF1" }}
    >
      {config && <config.Component farmerGuid={farmerGuid} />}
    </DetailDialog>
  );
}
